export type FeatureFlags = Record<string, boolean>;

export const FEATURE_FLAG_KEYS = {
  BILLING_SUBSCRIPTION_AREA: 'billing.subscriptionArea.enabled',
  LEGAL_CONTROL_QUEUE: 'legal_control_queue',
  CONSULTANCY_PROJECT_HIERARCHY: 'consultancy_project_hierarchy',
  DOCUMENT_GENERATOR: 'document_generator'
} as const;
